import { render, staticRenderFns } from "./PagamentosDash.vue?vue&type=template&id=4d210da3&"
import script from "./PagamentosDash.vue?vue&type=script&lang=js&"
export * from "./PagamentosDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports